// extracted by mini-css-extract-plugin
export default {"kpiGrid":"CurrencyAggregate_kpiGrid__Z2Pvl","tableCard":"CurrencyAggregate_tableCard__0PeNw"};